import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import RecipeLanding from "@/pages/RecipeLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminOrders from "@/pages/AdminOrders";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/receita" element={<RecipeLanding />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminOrders />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{
        style: {
          background: "#000",
          color: "#fff",
          border: "1px solid #000",
          borderRadius: 0,
          fontFamily: "Inter, sans-serif",
        }
      }} />
    </div>
  );
}

export default App;
